<template>
  <tr class="k-editable-table-row" :class="row ? classFunc(row) : ''" >
    <td v-if="!row" class="empty-table-row" :colspan="headers.length || 1">
      <p :role="loading ? 'status' : undefined" :aria-label="loading ? 'Loading' : undefined">
        {{ loading ? '' : emptyMessage }}
        <i v-if="loading" class="fas fa-spinner fa-spin" aria-hidden="true"></i>
      </p>
    </td>
    <td v-else v-for="header in headers">
      <k-cell
        :row="row"
        :header="header"
        :entry="row[header.key]"
        @update="updateCell(header.key, $event)"
        @commitEdits="commitEdits"
        @update-editing-state="updateEditingState"
        :preserved-editing-state="preservedEditingState[header.key]"
        :key="row._index + '-' + header.key"
        :timezone="timezone"
      ></k-cell>
    </td>
  </tr>
</template>

<style scoped>
.empty-table-row {
  text-align: center;
  padding: 15px;
  font-style: italic;
}

.empty-table-row .fa-spinner {
  font-size: 1.2em;
  margin-left: 10px;
}
</style>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_index"] }] */
import KCell from './k-editable-table-cell.vue';

export default {
  components: {
    'k-cell': KCell,
  },
  props: {
    row: Object,
    headers: Array,
    classFunc: {
      type: Function,
      default: () => '',
    },
    timezone: String,
    preservedEditingState: Object,
    loading: {
      type: Boolean,
      default: false,
    },
    emptyMessage: {
      type: String,
      default: 'No data found',
    },
  },
  methods: {
    update(newRow) {
      this.$emit('update', newRow);
    },
    updateCell(key, nuval) {
      const newRow = { ...this.row };
      newRow[key] = nuval;
      this.update(newRow);
    },
    commitEdits(payload) {
      this.$emit('commitEdits', payload);
    },
    updateEditingState(headerKey, editingState) {
      this.$emit('update-editing-state', this.row._index, headerKey, editingState);
    },
  },
};
</script>
